// src/components/SolicitudTrack.jsx
import React, { useState } from 'react';
import { Toaster, toast } from 'react-hot-toast';
import { getBitacoraSolicitud} from "../../services/Reportes.js";
import { formatDate } from '../../formatters/date';


//const formatDate = (d) => d || '-';
const showDays = (d) => (d === null || d === undefined ? '-' : `${d >= 0 ? '+'+d : d} d`);

export default function BitacoraSolicitud() {
  const [numero, setNumero] = useState('');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const fetchTrack = async (e) => {
    e && e.preventDefault();
    if (!numero) {
      toast.error('Ingrese N° de solicitud');
      return;
    }
    setLoading(true);
    try {

      const res =  await getBitacoraSolicitud(numero);
      
      if (!res) {
        const txt = await res.text();
        throw new Error(txt || 'Error en API');
      }
      // const json = await res.json();
      setData(res);
    } catch (err) {
      console.error(err);
      toast.error('No se pudo obtener la solicitud');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-4 lg:mx-12 mt-4">
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                 Bitácora Solicitud
              </p>
            </div>
        </div>    
        <Toaster />
        <div className="bg-white p-6 rounded-lg shadow-lg items-end mt-4">
	        <div className="grid grid-cols-2 md:grid-cols-5 gap-4" >
            <div className="col-span-3">
            <div className="flex flex-col">
                <form onSubmit={fetchTrack} className="flex gap-2 items-center mb-4 mt-4">
                  <input
                    type="number"
                    placeholder="Número de Solicitud"
                    value={numero}
                    onChange={e => setNumero(e.target.value)}
                    className="border p-2 rounded w-44"
                  />
                  <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">
                    {loading ? 'Buscando...' : 'Buscar'}
                  </button>
                  <button type="button" onClick={() => { setNumero(''); setData(null); }} className="ml-2 px-3 py-2 border rounded">
                    Limpiar
                  </button>
                </form>
              {!data && (
                  <div className="text-sm text-gray-500">Ingrese un número y presione Buscar para ver la bitácora y plazos.</div>
                )}
            </div>
            </div>
            <div className="col-span-2">
              <div className="flex flex-col">
              {data && (
                <div className="flex justify-between items-center">
                  <div>
                    <h3 className="text-lg font-semibold">Solicitud N° {data.solicitud.numeroSolicitud}</h3>
                    <p className="text-sm text-gray-600">Tipo: {data.solicitud.tipoSolicitud} — Estado: {data.solicitud.estado}</p>
                    <p className="text-sm text-gray-500">Creada: {formatDate(data.solicitud.fechaCreacion)} — Aprobada: {formatDate(data.solicitud.fechaAprobacion) || '-'}</p>
                    <p className="text-sm text-gray-500">Asignaciones: {data.asignacionesCount}</p>
                  </div>
                </div>
              )}
              </div>
            </div>

          </div>
        </div>


      {data && (
        <div className="space-y-6">

          {/* Bitácora (timeline) */}
          <div className="bg-white p-4 rounded shadow">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-left">
                    <th className="p-2">FECHA</th>
                    <th className="p-2">ACCION</th>
                    <th className="p-2">MODULO</th>
                    <th className="p-2">DESCRIPCIÓN</th>
                    <th className="p-2">USUARIO</th>
                  </tr>
                </thead>
                <tbody>
                  {data.bitacora.length === 0 && <tr className="border-t">Sin eventos</tr>}
                  {data.bitacora.map((eq, i) => (
                    <tr key={i} className="border-t">
                      <td className="p-2">{formatDate(eq.fecha)}</td>
                      <td className="p-2">{eq.accion}</td>
                      <td className="p-2">{eq.modulo}</td>
                      <td className="p-2">{eq.descripcion }</td>
                      <td className="p-2">{eq.usuario}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

          </div>

          {/* Tabla de equipos */}
          <div className="bg-white p-4 rounded shadow">
            <h4 className="font-semibold mb-3">Equipos - Días para entrega / autorización</h4>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="text-left">
                    <th className="p-2">LIN</th>
                    <th className="p-2">Máquina</th>
                    <th className="p-2">Es Crítico</th>
                    <th className="p-2">Fecha en Obra</th>
                    <th className="p-2">Días faltantes</th>
                    <th className="p-2">Fecha Autorización / Anulación</th>
                    <th className="p-2">Días a autorización</th>
                    <th className="p-2">Estado</th>
                  </tr>
                </thead>
                <tbody>
                  {data.equipos.map((eq, i) => (
                    <tr key={i} className="border-t">
                      <td className="p-2">{eq.lin}</td>
                      <td className="p-2">{eq.maquina?.nombre || eq.maquina?.codigo || '-'}</td>
                      <td className="p-2">{eq.esCritico ? 'Sí' : 'No'}</td>
                      <td className="p-2">{formatDate(eq.fechaEnObra)}</td>
                      <td className={`p-2 font-semibold ${eq.diasRestantes < 0 ? 'text-red-600' : 'text-green-600'}`}>{showDays(eq.diasRestantes)}</td>
                      <td className="p-2">{eq.fechaAutorizacion || '-'}</td>
                      <td className="p-2">{eq.diasAutorizacion !== null ? `${eq.diasAutorizacion} d` : '-'}</td>
                      <td className="p-2">{eq.estadoEquipo}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

        </div>
      )}
    </div>
  );
}
